import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c256daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "s-content-title" }


import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: ['model', 'orderFlag'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('商品基础信息')), 1),
    _createVNode(_component_el_form_item, {
      prop: "combinationProductName",
      label: _unref(t)('组合商品名称')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "text",
          class: "text-input",
          modelValue: __props.model.combinationProductName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.combinationProductName) = $event)),
          maxlength: 50,
          disabled: __props.orderFlag
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, {
      prop: "combinationProductProp",
      label: _unref(t)('组合商品规格')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "text",
          class: "text-input",
          modelValue: __props.model.combinationProductProp,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.model.combinationProductProp) = $event)),
          maxlength: 30,
          disabled: __props.orderFlag
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, {
      prop: "customerProductMsku",
      label: _unref(t)('客户商品sku')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "text",
          class: "text-input",
          modelValue: __props.model.customerProductMsku,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.model.customerProductMsku) = $event)),
          maxlength: 100
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"]),
    _renderSlot(_ctx.$slots, "pics"),
    _renderSlot(_ctx.$slots, "addition")
  ]))
}
}

})